{
  "INTERNAL_ERROR": "An unexpected error occurred. Please try again.",
  "BAD_REQUEST": "The request could not be processed.",
  "UNAUTHORIZED": "Your session is not valid. Please sign in again.",
  "FORBIDDEN": "You do not have permission to perform this action.",
  "NOT_FOUND": "We could not find what you are looking for.",
  "CONFLICT": "This action conflicts with existing data.",
  "TOO_MANY_REQUESTS": "Too many attempts. Please wait a moment and try again.",
  "SERVICE_UNAVAILABLE": "The service is unavailable right now.",
  "VALIDATION_FAILED": "Please check the data you submitted.",
  "VALIDATION_INVALID_FIELD": "The \"{{field}}\" field is invalid.",
  "RECORD_ALREADY_EXISTS": "A record with this data already exists ({{fields}}).",
  "RECORD_NOT_FOUND": "Record not found.",
  "RELATED_RECORD_NOT_FOUND": "Related record not found.",
  "RELATION_VIOLATION": "This action would break a relation between records.",
  "DATABASE_ERROR": "Error accessing data. Please try again.",
  "DATABASE_VALIDATION_ERROR": "The submitted data is invalid.",
  "TENANT_NOT_IDENTIFIED": "Member area not identified. Please check the access address."
}
